import { render, staticRenderFns } from "./wrongQuestionList.vue?vue&type=template&id=6278c56f&scoped=true&"
import script from "./wrongQuestionList.vue?vue&type=script&lang=js&"
export * from "./wrongQuestionList.vue?vue&type=script&lang=js&"
import style0 from "./wrongQuestionList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./wrongQuestionList.vue?vue&type=style&index=1&id=6278c56f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6278c56f",
  null
  
)

export default component.exports